import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Link from 'next/link';

export default function SuccessMessage() {
	return (
		<div className="bg-white rounded-xl shadow-xl p-12 text-center max-w-2xl mx-auto border border-gray-100">
			<motion.div
				initial={{ scale: 0.5, opacity: 0 }}
				animate={{ scale: 1, opacity: 1 }}
				transition={{ duration: 0.5, type: 'spring' }}
				className="flex justify-center mb-6"
			>
				<div className="bg-green-100 p-4 rounded-full">
					<CheckCircle className="size-16 text-green-600" />
				</div>
			</motion.div>

			<h2 className="text-3xl font-heading text-blue-dark mb-4">Aanvraag Ontvangen!</h2>
			<p className="text-gray-600 mb-8 leading-relaxed max-w-md mx-auto">
				Bedankt voor uw interesse. We hebben uw gegevens in goede orde ontvangen en nemen
				<span className="font-semibold text-blue-dark"> binnen enkele werkdagen </span>
				contact met u op.
			</p>

			<Button asChild variant="default" size="lg">
				<Link href="/">Terug naar Home</Link>
			</Button>
		</div>
	);
}
